// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZY4H","footer":"styles_footer__6L6Ed","passCodeTooltip":"styles_passCodeTooltip__ku0CR"};